import { endOfComment } from "./end-of-comment";

/**
 * Index of the `{` opening the meta the script BEGINS with, or -1. Only
 * whitespace and comments may precede it: a declaration quoted further down is
 * text the engine never runs, and recording it is worse than refusing.
 */
export function metaDeclarationOpen(script: string): number {
  const anchor = /export[ \t]+const[ \t]+meta[ \t]*=\s*\{/y;
  let at = 0;
  while (at < script.length) {
    if (/\s/.test(script[at] ?? "")) {
      at += 1;
      continue;
    }
    const comment = endOfComment(script, at);
    if (comment !== at) {
      at = comment + 1;
      continue;
    }
    anchor.lastIndex = at;
    return anchor.test(script) ? script.indexOf("{", at) : -1;
  }
  return -1;
}
